import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import classNames from 'classnames';
import DesignerListItem from 'apps/find-designers/components/Listing/DesignerListItem';
import BlankSlate from 'components/BlankSlate';
import initTypeform from 'utils/initTypeform';
import { Designers } from 'apps/find-designers/propTypes';
import { getComponentClasses } from '@99designs/common/utils/app';

class DesignerList extends Component {
    componentDidUpdate() {
        if (this.props.designers.length) return null;
        return initTypeform();
    }

    blankSlateMessage() {
        return (
            <span>
                <FormattedMessage id="blank_slate_message" />
                {this.typeformLink()}
            </span>
        );
    }

    typeformLink() {
        if (!this.props.currentUser.isIdentified) return null;

        return (
            <span>
                <br />
                <FormattedHTMLMessage
                    id="typeform_feedback_link_blank_slate_html"
                    values={{
                        href: 'https://99designs1.typeform.com/to/g9Yzq9',
                        className: 'link typeform-share',
                        dataMode: 'drawer_left',
                    }}
                />
            </span>
        );
    }

    blankSlate() {
        if (this.props.designers.length) return null;

        return (
            <BlankSlate
                title={<FormattedMessage id="no_designers_found" />}
                message={this.blankSlateMessage()}
                variations={['wide', 'padded-top']}
            />
        );
    }

    render() {
        const classes = getComponentClasses('designer-list', [
            classNames({ 'loading-overlay': this.props.isLoading }),
        ]);

        return (
            <div className={classes}>
                {this.blankSlate()}
                {this.props.designers.map(designer => (
                    <DesignerListItem
                        key={designer.id}
                        designer={designer}
                        designs={designer.designs}
                        urls={designer.urls}
                        expertiseCategories={designer.expertiseCategories}
                    />
                ))}
            </div>
        );
    }
}

DesignerList.defaultProps = {
    designers: [],
    isLoading: false,
    currentUser: {
        isIdentified: false,
    },
};

DesignerList.propTypes = {
    designers: Designers.isRequired,
    isLoading: PropTypes.bool,
    currentUser: PropTypes.shape({
        isIdentified: PropTypes.bool,
    }),
};

export default DesignerList;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/DesignerList.jsx